module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wob-shareholder-misalignment.json
// module id = 1541
// module chunks = 135720351633282